import { Flex } from '@chakra-ui/react'
import React from 'react'
import HeroCard from '../Components/HeroCard'
import Navbarfun from './Navbar'
import TopSection from '../Components/TopSection'
const Homepage = () => {

  return (
    <div className="App" id="home">
    <Flex className='top'>
     <TopSection />
    </Flex>
    <div>
     <HeroCard />
    </div>
      
    </div>
  )
}

export default Homepage